import { createStore } from "vuex";
const store = createStore({
  modules: {
  },
});

export default store;
